/**
 * Board Games config API — manages the hr-campaigns "Board Games" page's
 * game list (src/alt/backgroundFill/url/type/order/startDate/endDate),
 * stored in the `gameConfigs` Firestore collection via hr-server's
 * /api/multiplayer/gamesConfig endpoints.
 */
import { http } from "@/lib/http";

export function fetchBoardGames() {
  return http
    .get("/api/multiplayer/gamesConfig")
    .then((res) => res.data?.data ?? []);
}

export function fetchBoardGame(gameName) {
  return http
    .get(`/api/multiplayer/gamesConfig/${gameName}`)
    .then((res) => res.data?.data ?? null);
}

export function createBoardGame(payload) {
  return http
    .post("/api/multiplayer/gamesConfig", payload)
    .then((res) => res.data);
}

export function updateBoardGame(gameName, payload) {
  return http
    .put(`/api/multiplayer/gamesConfig/${gameName}`, payload)
    .then((res) => res.data);
}

export function deleteBoardGame(gameName) {
  return http
    .delete(`/api/multiplayer/gamesConfig/${gameName}`)
    .then((res) => res.data);
}
